import { render, staticRenderFns } from "./PanelBackgroundColorSelector.vue?vue&type=template&id=1498b90c&scoped=true"
import script from "./PanelBackgroundColorSelector.vue?vue&type=script&lang=js"
export * from "./PanelBackgroundColorSelector.vue?vue&type=script&lang=js"
import style0 from "./PanelBackgroundColorSelector.vue?vue&type=style&index=0&id=1498b90c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1498b90c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1498b90c')) {
      api.createRecord('1498b90c', component.options)
    } else {
      api.reload('1498b90c', component.options)
    }
    module.hot.accept("./PanelBackgroundColorSelector.vue?vue&type=template&id=1498b90c&scoped=true", function () {
      api.rerender('1498b90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/PanelBackgroundColorSelector.vue"
export default component.exports